












import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class UnauthorizedPage extends Vue {
  private back() {
    this.$router.push('/');
  }
}
